import { h, Component } from 'preact'
import PhoneNumber from 'awesome-phonenumber'
import emojiFlags from 'emoji-flags'
import AuthStep from '../AuthStep'
import { Button } from '../../UI/Button'
import { Select } from '../../UI/Select'
import { Input } from '../../UI/Input'
import { Checkbox } from '../../UI/Checkbox'
import CountryOption from '../CountryOption'
import tdlib from '../../utils/tdlib'
import Logo from './icons/logo.png'
import s from './PhoneForm.css'

interface iState {
  country: string
  phone: string
  errorCode: string | null
  isKept: boolean
  isValid: boolean
  isLoading: boolean
}

class PhoneForm extends Component<{}, iState> {
  state = {
    country: '',
    phone: '',
    errorCode: null,
    isKept: true,
    isValid: false,
    isLoading: false
  }

  getCountryData = (value: string) => {
    if (value) {
      return emojiFlags.data.find(({ name, code }) => (
        name.toLowerCase() === value.toLowerCase() ||
        code.toLowerCase() === value.toLowerCase()
      ))
    }
  }

  onChangePhone = (e: Event) => {
    const { value } = e.target as HTMLInputElement
    const phoneNumber = value.replace(/d/g, '')
    const phone = !phoneNumber || phoneNumber.charAt(0) === '+'
      ? phoneNumber
      : `+${phoneNumber}`

    const pn = new PhoneNumber(phone)
    const regionCode = pn.getRegionCode()
    const countryData = this.getCountryData(regionCode)
    const country = countryData
      ? countryData.name
      : ''

    return this.setState({
      errorCode: null,
      phone: pn.getNumber('international') || phone,
      isValid: pn.isValid(),
      country
    })
  }

  onChangeCountry = (value: string) => {
    const countryData = this.getCountryData(value)
    const phoneCode: number | string = countryData
      ? PhoneNumber.getCountryCodeForRegionCode(countryData.code)
      : ''

    return this.setState({
      isValid: false,
      errorCode: null,
      country: value,
      phone: `+${phoneCode}`
    })
  }

  handleCheckbox = () => {
    this.setState({
      isKept: !this.state.isKept
    })
  }

  submitForm = (e: Event) => {
    e.preventDefault()
    const { phone } = this.state

    this.setState({
      isLoading: true
    })

    tdlib
      .send({
        '@type': 'setAuthenticationPhoneNumber',
        phone_number: phone
      })
      .then(() => {})
      .catch(err => {
        this.setState({
          isLoading: false,
          errorCode: err.message
        })
      })
  }

  render () {
    const {
      country,
      phone,
      errorCode,
      isKept,
      isValid,
      isLoading
    } = this.state

    return (
      <AuthStep
        image={(
          <div className={s.PhoneForm__logo}>
            <img src={Logo}/>
          </div>
        )}
        title="Sign in to Telegram"
        text={(
          `Please confirm your country and
            enter your phone number`
        )}
      >
        <form
          className={s.PhoneForm}
          onSubmit={this.submitForm}
        >
          <Select
            className={s.PhoneForm__field}
            onChange={this.onChangeCountry}
            value={country}
            placeholder="Country"
            name="country"
          >
            {emojiFlags.data.map(({ unicode, name, code, emoji }) => (
              <CountryOption
                key={code}
                value={unicode}
                label={name}
                flag={emoji}
                code={PhoneNumber.getCountryCodeForRegionCode(code)}
              />
            ))}
          </Select>

          <Input
            className={s.PhoneForm__field}
            label={errorCode || 'Phone number'}
            invalid={!!errorCode}
            onInput={this.onChangePhone}
            value={phone}
            name="phone"
            autoFocus
          />

          <div className={s.PhoneForm__checkbox}>
            <Checkbox
              onChange={this.handleCheckbox}
              checked={isKept}
            >
          <span class={s.PhoneForm__checkboxLabel}>
            Keep me signed in
          </span>
            </Checkbox>
          </div>

          {isValid && (
            <Button
              className={s.PhoneForm__submit}
              isLoading={isLoading}
            >
              Next
            </Button>
          )}
        </form>
      </AuthStep>
    )
  }
}

export default PhoneForm
